import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  columnWidthsStorageKey,
  withColumnWidth,
  type ColumnWidths,
} from '../lib/columnWidths';

interface ColumnWidthsStore {
  /** Clé `<collaborateur>:<tableau>` → largeurs par colonne. */
  widths: Record<string, ColumnWidths>;
  setWidth: (collaboratorId: string, tableId: string, column: string, px: number | null) => void;
}

/** Largeurs de colonnes, par utilisateur et par tableau (mémorisées sur le poste). */
export const useColumnWidthsStore = create<ColumnWidthsStore>()(
  persist(
    (set) => ({
      widths: {},
      setWidth: (collaboratorId, tableId, column, px) =>
        set((state) => {
          const key = columnWidthsStorageKey(collaboratorId, tableId);
          return {
            widths: { ...state.widths, [key]: withColumnWidth(state.widths[key] ?? {}, column, px) },
          };
        }),
    }),
    { name: 'cime.columns.widths' },
  ),
);
